import { defineStore } from 'pinia';
import { ref } from 'vue';

const useMerchantIdStore = defineStore('merchant-id', () => {
  const merchantId = ref(0);

  function setMerchantId(value: number | undefined): void {
    merchantId.value = value || 0;
  }

  return {
    merchantId,
    setMerchantId,
  };
});

export default useMerchantIdStore;
